import React, { Component } from "react";
import styled, { css } from "styled-components";

import fileImg from "../images/passport-img.png";
import fileDelete from "../images/passport-del.png";
import fileDeleteHover from "../images/passport-del-hover.png";
import fileView from "../images/passport-view.png";
import fileViewHover from "../images/passport-view-hover.png";

const File = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: table;
  margin: 0px;
`;

const Cell = styled.div`
  display: table-cell;
  vertical-align: middle;
  min-width: 30px;
  margin: 0px;
  padding: 0px;
  @media (max-width: 320px) {
    min-width: 24px;
  }
`;

const Grow = styled(Cell)`
  width: 100%;
  text-align: left;
  padding-left: 10px;
  position: relative;
  overflow: hidden;
  :before {
    content: "......................................................................................................................................................................................................................................................................................................................";
    position: absolute;
    top: 0px;
    left: 10px;
    display: block;
    height: 100%;
    width: 100%;
    max-width: 1000px;
    font: 16px/39px Roboto, Arial, sans-serif;
    white-space: nowrap;
    text-overflow: clip;
    letter-spacing: -0.75px;
    color: #797979;
    overflow: hidden;
    z-index: 0;
    @media (max-width: 320px) {
      left: 6px;
      font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "14px"};
    }
  }
  @media (max-width: 320px) {
    padding-left: 6px;
  }
  
  ${props => props.theme.direction === "rtl" && css`
    padding-left: 0;
    padding-right: 10px;
    text-align: right;
    
    :before {
      left: auto;
      right: 10px;
      
      @media (max-width: 320px) {
        left: auto;
        right: 6px;
      }
    }
  `};
`;

const FileName = styled.p`
  position: relative;
  top: 2px;
  display: inline-block;
  max-width: 470px;
  margin: 0px;
  padding-right: 1px;
  box-sizing: border-box;
  font: 16px/39px Roboto, Arial, sans-serif;
  color: #797979;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #fff;
  @media (max-width: 640px) {
    top: 0px;
  }
  @media (max-width: 320px) {
    font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "14px"};
  }

  ${props => props.offpay && css`
    top: 0px;
    background: #f6f6f6;
  `}

  ${props => props.desktop && css`
    top: 0px;
    background: #f6f6f6;
  `}
`;

const FileNameColor = styled.span`
  color: ${props => props.theme.mainFontColor};
`;

const Img = styled.img`
  position: relative;
  top: -1px;
  display: block;
  height: 24px;
  width: auto;
  @media (max-width: 320px) {
    height: 20px;
  }

  ${props => props.desktop && css`
    top: 0px;
    height: 20px;
  `}
`;

const Action = styled.div`
  display: block;
  height: 22px;
  width: 100%;
  background: right bottom no-repeat;
  background-size: contain;
  border: none;
  transition: all 0.3s ease;
  cursor: pointer;
  @media (max-width: 320px) {
    height: 18px;
  }
  :hover {
    outline: none;
  }
  :focus {
    outline: none;
  }
  :active {
    outline: none;
  }
`;

const Delete = styled(Action)`
  margin-left: auto;
  background-image: url(${fileDelete});
  
  ${props => props.theme.direction === "rtl" && css`
    background-position-x: left;
  `};
  :hover {
    background-image: url(${fileDeleteHover});
  }
`;

const View = styled(Action)`
  background-image: url(${fileView});
  :hover {
    background-image: url(${fileViewHover});
  }

  ${props => props.activeView && css `
    background-image: url(${fileViewHover});
  `};
`;

class PassportFile extends Component {
  constructor(props) {
    super(props);

    this.onDeleteClick = this.onDeleteClick.bind(this);

    this.state = {
      fileReaderAPIisAvailable: FileReader && typeof FileReader === "function"
    };
  }

  onDeleteClick(e) {
    e.preventDefault();
    this.props.onDelete(this.props.fileIndex);
  }

  render() {
    const { onClick, name, offpay, desktop, activeView } = this.props;

    const viewable = this.props.viewable && /\.(jpg|jpeg|png|bmp|gif)$/i.test(name);

    const truncatedName = function(name) {
      let truncatedStr = name;
      const truncateTo = 20;
      const endChars = 4;
      const ellipsis = "...";

      if (name.length >= truncateTo) {
        const startChars = truncateTo - endChars - ellipsis.length;
        const truncatedStart = name.substring(0, startChars);
        const truncatedEnd = name.substring(
          name.length - endChars,
          name.length
        );
        truncatedStr = `${truncatedStart}${ellipsis}${truncatedEnd}`;
      }

      return truncatedStr;
    };

    return (
      <File>
        <Cell>
          <Img
            desktop={desktop}
            src={fileImg}
            alt={fileImg}
          />
        </Cell>
        <Grow>
          <FileName
            offpay={offpay}
            desktop={desktop}
          >
            <FileNameColor>
              {truncatedName(name)}
            </FileNameColor>
          </FileName>
        </Grow>
        {this.state.fileReaderAPIisAvailable &&
          viewable &&
          onClick &&
          <Cell>
            <View
              activeView={activeView}
              onClick={onClick}
            />
          </Cell>}
        <Cell>
          <Delete
            onClick={this.onDeleteClick}
          />
        </Cell>
      </File>
    );
  }
}

export default PassportFile;



// WEBPACK FOOTER //
// ./src/components/PassportFile.js